import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  SALES_CATALYST_DEFAULT_SELECTED_TAB,
  /* SALES_CATALYST_INPUTS, */
  // SALES_CATALYST_AUDIENCE_OVERLAP,
  /* SALES_CATALYST_PROFILE_DEEP_DIVE, */
  SALES_CATALYST_MEDIA_PACKAGE,
  SALES_CATALYST_TARGET_MARKET,
  SALES_CATALYST_COMPETITION,
  SALES_CATALYST_COMPETITION_LABEL,
  SALES_CATALYST_TARGET_TAB,
  SALES_CATALYST_MDEDIA_TAB,
  PAGE_VISIT_SALES_CATALYST,

 } from '../../constants';
import salesCatalystActive from '../../images/salescatalyst/SC_Logo_White.png';
import CompetitionInactive from '../../images/salescatalyst/CompetitionIcon_inactive.png';
import CompetitionActive from '../../images/salescatalyst/CompetitionIcon_Selected.png';
/* import inputsInactive from '../../images/salescatalyst/inputs_icon_default.png';
import inputsActive from '../../images/salescatalyst/inputs_icon_active.png';
import audienceDeepdiveInactive from '../../images/salescatalyst/SC_Audience_NotSelected.png';
import audienceDeepdiveActive from '../../images/salescatalyst/SC_Audience_Hover.png'; */
import mediaPlanInactive from '../../images/salescatalyst/media_plan_icon_default.png';
import mediaPlanActive from '../../images/salescatalyst/media_plan_icon_active.png';
import marketInactive from '../../images/salescatalyst/market_icon_default.png';
import marketActive from '../../images/salescatalyst/market_icon_active.png';


class SalesCatalystToolPalate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: SALES_CATALYST_DEFAULT_SELECTED_TAB,
      hoveredtab: SALES_CATALYST_DEFAULT_SELECTED_TAB,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.selectedTab !== nextProps.selectedTab) {
      this.setState({ selectedTab: nextProps.selectedTab });
    }
  }

  setTab = tabName => {
    if (tabName !== this.state.selectedTab) {
      this.props.trackerFn({ action: PAGE_VISIT_SALES_CATALYST, subModule: tabName });
    }
    this.setState({
      selectedTab: tabName,
    });
    this.props.onselectedtab(tabName);
  };

  setMouseHoverTab = hovtab => {
    this.setState({
      hoveredtab: hovtab,
    });
  };

  render() {
    return (
      <div className="insight360-width-455 minimize-tp float-left">
        <ul className="insight360_tool_bg">
          <li className="salescatalyst_tool_btn_sale">
            <button className="tool_img open_tool insight360_tool_btn deafult-cursor">
              <img
                className="salescatalyst_tool_img_sale"
                src={salesCatalystActive}
                alt=""
              />
            </button>
          </li>
          <li
            className={
              this.state.selectedTab === SALES_CATALYST_TARGET_MARKET ||
                this.state.hoveredtab === SALES_CATALYST_TARGET_MARKET
                ? 'insight360_tool_btn_others_active'
                : 'insight360_tool_btn_others'
            }
          >
            <button
              onClick={() => this.setTab(SALES_CATALYST_TARGET_MARKET)}
              className="tool_img open_tool salescatalyst_tool_btn_audience"
              onMouseOver={() => this.setMouseHoverTab(SALES_CATALYST_TARGET_MARKET)}
              onMouseOut={() => this.setMouseHoverTab('')}
            >
              <img
                className="salescatalyst_tool_img_market"
                src={
                  this.state.selectedTab === SALES_CATALYST_TARGET_MARKET ||
                    this.state.hoveredtab === SALES_CATALYST_TARGET_MARKET
                    ? marketActive
                    : marketInactive
                }
                alt="MARKET"
              />
              <p
                className={
                  this.state.selectedTab === SALES_CATALYST_TARGET_MARKET ||
                    this.state.hoveredtab === SALES_CATALYST_TARGET_MARKET
                    ? 'insight360_salescatalyst_tool_btn_text_active'
                    : 'insight360_salescatalyst_tool_btn_text_default'
                }
              >
                {SALES_CATALYST_TARGET_TAB}
              </p>
            </button>
          </li>
          <li
            className={
              this.state.selectedTab === SALES_CATALYST_MEDIA_PACKAGE ||
                this.state.hoveredtab === SALES_CATALYST_MEDIA_PACKAGE
                ? 'insight360_tool_btn_others_active'
                : 'insight360_tool_btn_others'
            }
          >
            <button
              onClick={() => this.setTab(SALES_CATALYST_MEDIA_PACKAGE)}
              className="tool_img open_tool salescatalyst_tool_btn_audience"
              onMouseOver={() => this.setMouseHoverTab(SALES_CATALYST_MEDIA_PACKAGE)}
              onMouseOut={() => this.setMouseHoverTab('')}
            >
              <img
                className="salescatalyst_tool_img_media"
                src={
                  this.state.selectedTab === SALES_CATALYST_MEDIA_PACKAGE ||
                    this.state.hoveredtab === SALES_CATALYST_MEDIA_PACKAGE
                    ? mediaPlanActive
                    : mediaPlanInactive
                }
                alt="MEDIA_PLAN"
              />
              <p
                className={
                  this.state.selectedTab === SALES_CATALYST_MEDIA_PACKAGE ||
                    this.state.hoveredtab === SALES_CATALYST_MEDIA_PACKAGE
                    ? 'insight360_salescatalyst_tool_btn_text_active'
                    : 'insight360_salescatalyst_tool_btn_text_default'
                }
              >
                {SALES_CATALYST_MDEDIA_TAB}
              </p>
            </button>
          </li>
          <li
            className={
              this.state.selectedTab === SALES_CATALYST_COMPETITION ||
                this.state.hoveredtab === SALES_CATALYST_COMPETITION
                ? 'insight360_tool_btn_others_active'
                : 'insight360_tool_btn_others'
            }
          >
            <button
              onClick={() => this.setTab(SALES_CATALYST_COMPETITION)}
              className="tool_img open_tool salescatalyst_tool_btn_audience"
              onMouseOver={() => this.setMouseHoverTab(SALES_CATALYST_COMPETITION)}
              onMouseOut={() => this.setMouseHoverTab('')}
            >
              <img
                className="salescatalyst_tool_img_audience_overlap"
                src={
                  this.state.selectedTab === SALES_CATALYST_COMPETITION ||
                    this.state.hoveredtab === SALES_CATALYST_COMPETITION
                    ? CompetitionActive
                    : CompetitionInactive
                }
                alt="SALES_CATALYST_COMPETITION_LABEL"
              />
              <p
                className={
                  this.state.selectedTab === SALES_CATALYST_COMPETITION ||
                    this.state.hoveredtab === SALES_CATALYST_COMPETITION
                    ? 'insight360_salescatalyst_tool_btn_text_active'
                    : 'insight360_salescatalyst_tool_btn_text_default'
                }
              >
                {SALES_CATALYST_COMPETITION_LABEL}
              </p>
            </button>
          </li>
        </ul>
      </div>
    );
  }
}

SalesCatalystToolPalate.propTypes = {
  onselectedtab: PropTypes.func,
  trackerFn: PropTypes.func,
};


export default SalesCatalystToolPalate;
